import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { cn } from '../../../utils/cn';

const AgentCard = ({ agent, onSelect }) => {
  const getRoleIcon = (role) => {
    const icons = {
      coordinator: 'Users',
      validator: 'CheckCircle',
      analyst: 'BarChart',
      auditor: 'Shield',
      specialist: 'Sparkles'
    };
    return icons?.[role] || 'Bot';
  };

  const getStatusColor = (status) => {
    const colors = {
      available: 'bg-success',
      busy: 'bg-warning',
      offline: 'bg-muted'
    };
    return colors?.[status] || 'bg-muted';
  };

  return (
    <div className="border border-border rounded-lg p-4 bg-card hover:shadow-md transition-shadow">
      <div className="flex items-start gap-3 mb-3">
        <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
          <Icon name={getRoleIcon(agent?.role)} size={24} color="var(--color-primary)" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-semibold text-foreground truncate">{agent?.name}</h3>
          <div className="flex items-center gap-2 mt-1">
            <span className={cn('w-2 h-2 rounded-full', getStatusColor(agent?.status))}></span>
            <span className="text-sm text-muted-foreground capitalize">{agent?.status}</span>
          </div>
        </div>
      </div>

      <p className="text-sm text-muted-foreground mb-3 line-clamp-2">
        {agent?.description}
      </p>

      {agent?.specialization && agent?.specialization?.length > 0 && (
        <div className="flex flex-wrap gap-1 mb-3">
          {agent?.specialization?.slice(0, 3)?.map((spec, index) => (
            <span
              key={index}
              className="text-xs bg-secondary text-secondary-foreground px-2 py-1 rounded"
            >
              {spec}
            </span>
          ))}
        </div>
      )}

      <Button
        variant="default"
        size="sm"
        fullWidth
        iconName="MessageSquare"
        onClick={() => onSelect?.(agent)}
        disabled={agent?.status === 'offline'}
      >
        Start Chat
      </Button>
    </div>
  );
};

export default AgentCard;